/** CSGSphere3D's solid, exposed to the boolean evaluator. */
import { primitiveSolid } from '../../../../r3f/csg/csgRegistration';
import { buildCsgSphereGeometry } from './sphereGeometry';
export const csgSphere3DGeometry = (properties) => {
    const p = properties;
    return primitiveSolid(buildCsgSphereGeometry({
        radius: p.radius,
        radialSegments: p.radialSegments,
        rings: p.rings,
        smoothFaces: p.smoothFaces,
        flipFaces: p.flipFaces,
    }), p);
};
export function csgSphere3DGeometryKey(properties) {
    const p = properties;
    return `sph:${p.radius},${p.radialSegments},${p.rings},${p.smoothFaces},${p.flipFaces}`;
}
//# sourceMappingURL=csgGeometry.js.map